import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Portal from './Portal';

function Modal({
  title, children, handleClick, type, zIndex, positionMiddle, size, singleUploader, background,
}) {
  const elem = React.createRef();
  useEffect(() => {
    elem.current.focus();
  }, []);

  const closeLittleModal = () => {
    if (zIndex) {
      return handleClick(type);
    }
    return null;
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Escape') {
      handleClick(type);
    }
  };

  return (
    <Portal>
      <div className={`fixed flex-col w-full h-screen flex ${positionMiddle ? 'justify-center' : 'justify-start pt-8'} pin-t pin-l z-top items-center `} tabIndex="0" onKeyDown={handleKeyPress} ref={elem}>
        <div className={`relative text-white rounded-lg opacity-1 h-fit-content overflow-x-hidden ${size} ${background || 'px-4 overflow-auto scrollbar__black bg-black'} z-${zIndex || '50'} ${!positionMiddle ? 'max-h-[90vh]' : ''}`}>
          <div className={`flex justify-between items-center w-full absolute p-2 pr-5 pl-4 z-${zIndex}`}>
            <span className="font-americaMonoBold text-sm uppercase py-4">{title && title}</span>
            <button type="button" onClick={() => handleClick(type)}>
              <span className={`${background ? 'absolute mt-0 -ml-8 text-white' : 'pr-4  text-white'} font-icon icon-close-btn1 text-24`} />
            </button>
          </div>
          <div className={`${background ? 'pt-4' : 'pt-6'} z-${zIndex}`}>{children}</div>
        </div>
        {/* <div className={`absolute w-full h-screen ${!zIndex || (singleUploader && 'bg-black opacity-75')}`} onClick={closeLittleModal} /> */}
        <div className="absolute w-full h-screen bg-black opacity-75 fixed" onClick={closeLittleModal} />
      </div>
    </Portal>
  );
}

Modal.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
  children: PropTypes.shape().isRequired,
  zIndex: PropTypes.string,
  positionMiddle: PropTypes.bool,
  size: PropTypes.string,
  background: PropTypes.string,
  closeButton: PropTypes.string,
  singleUploader: PropTypes.bool,
};

Modal.defaultProps = {
  zIndex: null,
  type: null,
  positionMiddle: false,
  title: null,
  size: 'w-5/6',
  background: '',
  closeButton: '',
  singleUploader: false,
};

export default Modal;
